import type { AdWithCreativeRefInput, CreativeWithRefInput } from '../../../../../../../../apis/graphql/types';
import type { TagSheetParseResult } from '../../../../types';
import { getSubmittableMappedAds } from '../../../../validation/validateLineItems';
import { convertTagSheetAdToAdInput } from './convertTagSheetAdToAdInput';
import { convertTagSheetAdToCreativeInput } from './convertTagSheetAdToCreativeInput';

export type CreateAdsWithCreativesInput = {
  ads: AdWithCreativeRefInput[];
  creatives: CreativeWithRefInput[];
};

export const prepareCreateAdsWithCreativesInput = (
  parseResult: TagSheetParseResult,
  creativeLibraryId: string
): CreateAdsWithCreativesInput | null => {
  const ads: AdWithCreativeRefInput[] = [];
  const creatives: CreativeWithRefInput[] = [];

  for (const { tagSheetAd, lineItem } of getSubmittableMappedAds(parseResult)) {
    const creativeInput = convertTagSheetAdToCreativeInput(tagSheetAd, creativeLibraryId);

    if (!creativeInput) return null;

    const adInput = convertTagSheetAdToAdInput(tagSheetAd, lineItem, creativeInput.ref);

    if (!adInput) return null;

    creatives.push(creativeInput);
    ads.push(adInput);
  }

  return ads.length > 0 ? { ads, creatives } : null;
};
